export const errorPage = {
  // META
  'error_page.meta.title.not_found': 'Stránka nenalezena',
  'error_page.meta.title.server_error': 'Chyba serveru',

  //  HEADER TEXTS
  'error_page.page_title': 'Chybička se vloudila',
  'error_page.page_subtitle.not_found':
    'Je nám líto, stránka nebyla nalezena. Nejspíš byla zadána špatná adresa, nebo je odkaz neplatný.',
  'error_page.page_subtitle.server_error': 'Došlo k chybě na serveru',
  'error_page.what_next': 'Co dál?',

  //   BOX TEXTS
  'error_page.box_atlas.title': 'Atlas cen',
  'error_page.box_atlas.subtitle':
    'Zjistěte snadno a rychle ceny prodaných nemovitostí kolem vás.',
  'error_page.box_atlas.link_text': 'Otevřít Atlascen.cz',

  'error_page.box_news_blog.title': 'Chci vědět víc',
  'error_page.box_news_blog.subtitle':
    'Na našem blogu najdete spoustu tipů, jak prodat svou nemovitost lépe.',
  'error_page.box_news_blog.link_text': 'Přejít na Blog',

  'error_page.box_reas_story.title': 'Příběh Reas.cz',
  'error_page.box_reas_story.subtitle':
    'Kdo jsme, co děláme a čeho chceme dosáhnout? Přečtěte si náš příběh.',
  'error_page.box_reas_story.link_text': 'Více o firmě',
};
